module.exports = __webpack_public_path__ + "img/48.68a7d1b4.jpg";